import { formatInternational } from "@/helpers/phone_number/phone_number.helpers";
import { TFunction } from "i18next";

/**
 * Derives up to two uppercase initials from a name, matching the behavior of
 * the former tractor `AvatarText`/`getInitials` helper.
 */
export function getInitials(name: string) {
  return name
    .toUpperCase()
    .split(" ")
    .slice(0, 2)
    .map((word) => word[0])
    .join("");
}

export function getTooltipContent(
  t: TFunction,
  fullName?: string | null,
  companyName?: string | null,
  number?: string
) {
  if (fullName && companyName) {
    return `${fullName} ${t("call_details.at_company", {
      company: companyName,
    })}`;
  }
  if (fullName) {
    return fullName;
  }
  if (number) {
    return formatInternational(number);
  }
  return "";
}
